// © 2025 Camp Promethean, LLC. All Rights Reserved.
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Prefer environment variables to allow separate dev/prod projects
const envUrl = (import.meta as any)?.env?.VITE_SUPABASE_URL as string | undefined;
const envAnon = (import.meta as any)?.env?.VITE_SUPABASE_ANON_KEY as string | undefined;

const SUPABASE_URL = envUrl || "https://bjvlynqjoetvrbbfvhod.supabase.co";

// Publishable key (sb_publishable_…) — public by design, safe to ship in the browser bundle.
// Prefer VITE_SUPABASE_ANON_KEY for dev/prod project separation; otherwise use the current
// publishable key. NOTE: the previous fallback was the legacy anon JWT, which is HS256-signed
// and is being revoked — do NOT restore that value here. Only ever the sb_publishable_ key.
const SUPABASE_PUBLISHABLE_KEY = envAnon || "sb_publishable_xgF4J95nJxBAO1EFde4Npw_Ugvzw6uU";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storageKey: 'camp-promethean-auth',
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});